module.exports = __webpack_public_path__ + "static/img/target-oxbridge-2018.383b843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/target-oxbridge-2018.png
// module id = 7Pjv
// module chunks = 0